<app-page>
  <app-page-title 
    [title]="'MANAGE-LEARNING-PATH.OVERVIEW.TITLE' | translate"
  >
    <dx-button
      class="cta-btn"
      type="normal"
      icon="add"
      [text]="
        'MANAGE-LEARNING-PATH.OVERVIEW.ADD-LEARNING-PATH' 
          | translate
      "
      (click)="navigateToNewLearningPath()"
    ></dx-button>
  </app-page-title>
  <app-table
    [data]="learningPaths"
    [columns]="learningPathColumns"
    [showSearch]="true"
    [searchLabel]="'COMMON.SEARCH' | translate"
    [searchPlacehoder]="'COMMON.SEARCH' | translate"
    (onRowClick)="learningPathNavigateHandler($event)"
    [stateKey]="learningPathsStateKey"
    [showFilterPanel]="true"
  ></app-table>
</app-page>
